

/**
 * 添加style标签
 * @param {*} array 
 * @param {*} size 
 */
export const addStyle = function (styleContent) {
  var style = document.createElement('style');
  style.type = 'text/css';
  style.innerHTML = styleContent
  document.getElementsByTagName('head').item(0).appendChild(style);
}

/**
 * 替换地址栏的某个参数值
 * @param {*} array 
 * @param {*} size 
 */

export const changeURLArg = function (url,arg,arg_val){ 
  var pattern=arg+'=([^&]*)'; 
  var replaceText=arg+'='+arg_val; 
  if(url.match(pattern)){ 
      var tmp='/('+ arg+'=)([^&]*)/gi'; 
      tmp=url.replace(eval(tmp),replaceText); 
      return tmp; 
  }else{ 
      if(url.match('[\?]')){ 
          return url+'&'+replaceText; 
      }else{ 
          return url+'?'+replaceText; 
      } 
  } 
  return url+'\n'+arg+'\n'+arg_val; 
} 

/**
 * 拆分数组
 */
export const chunk = function (array, size) {
  //获取数组的长度，如果你传入的不是数组，那么获取到的就是undefined
  const length = array.length
  //判断不是数组，或者size没有设置，size小于1，就返回空数组
  if (!length || !size || size < 1) {
    return []
  }
  //核心部分
  let index = 0 //用来表示切割元素的范围start
  let resIndex = 0 //用来递增表示输出数组的下标

  //根据length和size算出输出数组的长度，并且创建它。
  let result = new Array(Math.ceil(length / size))
  //进行循环
  while (index < length) {
    //循环过程中设置result[0]和result[1]的值。该值根据array.slice切割得到。
    result[resIndex++] = array.slice(index, (index += size))
  }
  //输出新数组
  return result
}

// 异步加载css文件
export const includeCss = function (filename) {
  var head = document.getElementsByTagName("head")[0];
  var link = document.createElement("link");
  link.href = filename;
  link.rel = "stylesheet";
  link.type = "text/css";
  head.appendChild(link);
}

// 异步加载js文件
export const loadJs = function (libUrl, callback, libName) {
  if (window[libName]) {
    if (typeof callback === 'function') callback();
  }
  let head = document.getElementsByTagName("head")[0];
  let script = document.createElement("script");
  let isCallback = false;
  script.type = "text/javascript";
  script.src = libUrl;
  if (typeof callback == "function") {
    script.onload = script.onreadystatechange = function () {
      if (
        !this.readyState ||
        this.readyState === "loaded" ||
        this.readyState === "complete"
      ) {
        if (isCallback === false && typeof callback === 'function') {
          isCallback = true;
          callback();
        }
        script.onload = script.onreadystatechange = null;
      }
    };
  }
  head.appendChild(script);
}

// 获取当前滚动条高度
export const getScrollTop = function (params) {
  let scrollTop = 0;
  if (document.documentElement && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop;
  } else if (document.body) {
    scrollTop = document.body.scrollTop;
  }
  return scrollTop;
}

export const isPhone = function (poneInput) {
  var myreg = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/;
  if (!myreg.test(poneInput)) {
    return false;
  } else {
    return true;
  }
}
export const isCardID = function (card) { //验证身份证
  // let myreg=/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/;
  // if (!myreg.test(str)) {
  //     return false;
  // } else {
  //     return true;
  // }
  var vcity = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外"
  };

  let checkCard = function (card) {

    //是否为空
    if (card === '') {

      return false;
    }
    console.log(1)
    //校验长度，类型
    if (isCardNo(card) === false) {

      return false;
    }
    console.log(2)
    //检查省份
    if (checkProvince(card) === false) {
      return false;
    }
    console.log(3)
    //校验生日
    if (checkBirthday(card) === false) {
      return false;
    }
    console.log(4)
    //检验位的检测
    if (checkParity(card) === false) {
      return false;
    }
    console.log(5)

    return true;
  };


  //检查号码是否符合规范，包括长度，类型
  let isCardNo = function (card) {
    //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
    if (reg.test(card) === false) {
      return false;
    }

    return true;
  };

  //取身份证前两位,校验省份
  let checkProvince = function (card) {
    var province = card.substr(0, 2);
    if (vcity[province] == undefined) {
      return false;
    }
    return true;
  };

  //检查生日是否正确
  let checkBirthday = function (card) {
    var len = card.length;
    //身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
    if (len == '15') {
      var re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
      var arr_data = card.match(re_fifteen);
      var year = arr_data[2];
      var month = arr_data[3];
      var day = arr_data[4];
      var birthday = new Date('19' + year + '/' + month + '/' + day);
      return verifyBirthday('19' + year, month, day, birthday);
    }
    //身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
    if (len == '18') {
      var re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
      var arr_data = card.match(re_eighteen);
      var year = arr_data[2];
      var month = arr_data[3];
      var day = arr_data[4];
      var birthday = new Date(year + '/' + month + '/' + day);
      console.log('birthday',birthday)
      return verifyBirthday(year, month, day, birthday);
    }
    return false;
  };

  //校验日期
  let verifyBirthday = function (year, month, day, birthday) {
    var now = new Date();
    var now_year = now.getFullYear();
    //年月日是否合理
    if (birthday.getFullYear() == year && (birthday.getMonth() + 1) == month && birthday.getDate() == day) {
      //判断年份的范围（0岁到200岁之间)
      var time = now_year - year;
      if (time >= 0 && time <= 200) {
        return true;
      }
      return false;
    }
    return false;
  };

  //校验位的检测
  let checkParity = function (card) {
    //15位转18位
    card = changeFivteenToEighteen(card);
    var len = card.length;
    if (len == '18') {
      var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
      var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
      var cardTemp = 0,
        i, valnum;
      for (i = 0; i < 17; i++) {
        cardTemp += card.substr(i, 1) * arrInt[i];
      }
      valnum = arrCh[cardTemp % 11];
      if (valnum == card.substr(17, 1)) {
        return true;
      }
      return false;
    }
    return false;
  };

  //15位转18位身份证号
  let changeFivteenToEighteen = function (card) {
    if (card.length == '15') {
      var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
      var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
      var cardTemp = 0,
        i;
      card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6);
      for (i = 0; i < 17; i++) {
        cardTemp += card.substr(i, 1) * arrInt[i];
      }
      card += arrCh[cardTemp % 11];
      return card;
    }
    return card;
  };

  let flag = checkCard(card)
  return flag
}

// 16进制颜色转为RGB格式
export const colorToRgb = function (color = '#333333', transparency = 1) {
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  let sColor = color.toLowerCase();
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = "#";
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    //处理六位的颜色
    let sColorChange = [];
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
    }
    return "rgba(" + sColorChange.join(",") + ", " + transparency + ")";
  } else {
    return sColor;
  }
};

/**
 * URL解析生成方法
 * @param {*} fullPath 
 * @param {*} ridSecret 
 * @param {*} multiDisKey 
 */
export const urlParse = function (fullPath, object) {
  let query = {};
  let base = fullPath;
  if (fullPath.indexOf("?") !== -1) {
    base = fullPath.split("?")[0];
    let pathArr = fullPath.split("?")[1].split("&");
    pathArr.forEach(item => {
      let tempArr = item.split("=");
      let key = tempArr[0];
      let value = tempArr[1];
      query[key] = value;
    });
  }
  for (const key in object) {
    if (object.hasOwnProperty(key)) {
      const value = object[key];
      if (value && value !== 'empty') {
        query[key] = value;
      }
    }
  }
  let path = "";
  for (const key in query) {
    const value = query[key];
    path = path + key + "=" + value + "&";
  }
  let newPath = path.substring(0, path.length - 1);
  if (newPath) {
    return base + "?" + newPath;
  } else {
    return base;
  }
}

/**
 * 替换RidSecret（废弃）
 * @param {*} fullPath 
 * @param {*} ridSecret 
 * @param {*} multiDisKey 
 */
export const replaceRidSecret = function (fullPath, ridSecret, multiDisKey) {
  let query = {};
  if (fullPath.indexOf("?") !== -1) {
    let pathArr = fullPath.split("?")[1].split("&");
    pathArr.forEach(item => {
      let tempArr = item.split("=");
      let key = tempArr[0];
      let value = tempArr[1];
      query[key] = value;
    });
  }
  if (ridSecret) {
    query.ridSecret = ridSecret;
  }
  if (multiDisKey) {
    query.multiDisKey = multiDisKey;
  }
  let path = "";
  for (const key in query) {
    const value = query[key];
    path = path + key + "=" + value + "&";
  }
  return "?" + path.substring(0, path.length - 1);
}

//获取运行环境
export const getRunEnv = function () {
  let userAgent = navigator.userAgent.toLowerCase();
  let name = 'Unknown';
  let version = "Unknown";
  if (userAgent.indexOf("win") > -1) {
    name = "Windows";
    if (userAgent.indexOf("windows nt 5.0") > -1) {
      version = "Windows 2000";
    } else if (userAgent.indexOf("windows nt 5.1") > -1 || userAgent.indexOf("windows nt 5.2") > -1) {
      version = "Windows XP";
    } else if (userAgent.indexOf("windows nt 6.0") > -1) {
      version = "Windows Vista";
    } else if (userAgent.indexOf("windows nt 6.1") > -1 || userAgent.indexOf("windows 7") > -1) {
      version = "Windows 7";
    } else if (userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows 8") > -1) {
      version = "Windows 8";
    } else if (userAgent.indexOf("windows nt 6.3") > -1) {
      version = "Windows 8.1";
    } else if (userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows nt 10.0") > -1) {
      version = "Windows 10";
    } else {
      version = "Unknown";
    }
  } else if (userAgent.indexOf("iphone") > -1) {
    name = "Iphone";
  } else if (userAgent.indexOf("mac") > -1) {
    name = "Mac";
  } else if (userAgent.indexOf("x11") > -1 || userAgent.indexOf("unix") > -1 || userAgent.indexOf("sunname") > -1 || userAgent.indexOf("bsd") > -1) {
    name = "Unix";
  } else if (userAgent.indexOf("linux") > -1) {
    if (userAgent.indexOf("android") > -1) {
      name = "Android"
    } else {
      name = "Linux";
    }

  } else {
    name = "Unknown";
  }
  let os = new Object();
  os.name = name;
  os.version = version;

  return {
    os: os,
    browser: {}
  }
}

// 随机数
export const randomNum = function(Min, Max) {
  let Range = Max - Min;
  let Rand = Math.random();
  let num = Min + Math.round(Rand * Range); //四舍五入
  return num;
}

//校验手机号码
export const checkMobile = function (sMobile) {
  if (!sMobile || sMobile.length < 11) {
    return false;
  }
  if (!(/^1[3|4|5|8][0-9]\d{4,8}$/.test(sMobile))) {
    return false;
  } else {
    return true;
  }
}

const yiduiUrlArray = [
  'http://fimage.huaxiyou.cc/3070_1550477023581.235x235', //0
  'http://fimage.huaxiyou.cc/3070_1551077448152.235x235', //1
  'http://fimage.huaxiyou.cc/3070_1550477039743.235x235', //2
  'http://fimage.huaxiyou.cc/3070_1552372299685.235x235', //3
  'http://fimage.huaxiyou.cc/3070_1551334000081.235x235', //4
  'http://fimage.huaxiyou.cc/3070_1550477116226.235x235', //5
  'http://fimage.huaxiyou.cc/3070_1548758361504.235x235', //6
  'http://fimage.huaxiyou.cc/3070_1550477139011.235x235', //7
  'http://fimage.huaxiyou.cc/3070_1551076770628.235x235', //8
  'http://fimage.huaxiyou.cc/3070_1551076807281.235x235', //9
  'http://fimage.huaxiyou.cc/3070_1551076836022.235x235', //10
  'http://fimage.huaxiyou.cc/3070_1551345624546.235x235', //11
  'http://fimage.huaxiyou.cc/3070_1551077232688.235x235', //12
  'http://fimage.huaxiyou.cc/3070_1548758522155.235x235', //13
  'http://fimage.huaxiyou.cc/3070_1548758502584.235x235', //14
  'http://fimage.huaxiyou.cc/3070_1551076904346.235x235', //15
  'http://fimage.huaxiyou.cc/3070_1551076992362.235x235', //16    
  'http://fimage.huaxiyou.cc/3070_1551774892091.235x235', //17
  'http://fimage.huaxiyou.cc/3070_1551077474657.235x235', //18
  'http://fimage.huaxiyou.cc/3070_1552010681172.235x235', //19
  'http://fimage.huaxiyou.cc/3070_1550477437207.235x235', //20    
  'http://fimage.huaxiyou.cc/3070_1551774911845.235x235', //21
  'http://fimage.huaxiyou.cc/3070_1548758779329.235x235', //22
  'http://fimage.huaxiyou.cc/3070_1550477746321.235x235', //23
  'http://fimage.huaxiyou.cc/3070_1550477760777.235x235', //24
  'http://fimage.huaxiyou.cc/3070_1551345658769.235x235', //25
  'http://fimage.huaxiyou.cc/3070_1551236670345.235x235', //26
  'http://fimage.huaxiyou.cc/3070_1551256898725.235x235', //27
  'http://fimage.huaxiyou.cc/3070_1551256930907.235x235', //28
  'http://fimage.huaxiyou.cc/3070_1551281750288.235x235', //29
  'http://fimage.huaxiyou.cc/3070_1552372040890.235x235', //30
  'http://fimage.huaxiyou.cc/3070_1552372187281.235x235', //31
  'http://fimage.huaxiyou.cc/3070_1552372239909.235x235', //32
  'http://fimage.huaxiyou.cc/3070_1552372224601.235x235', //33
  'http://fimage.huaxiyou.cc/3070_1552372211058.235x235', //34
  'http://fimage.huaxiyou.cc/3070_1552977266298.235x235', //35
  'http://fimage.huaxiyou.cc/3070_1552977293434.235x235', //36
  'http://fimage.huaxiyou.cc/3070_1553587930597.235x235', //37
  'http://fimage.huaxiyou.cc/3070_1553588265271.235x235', //38
  'http://fimage.huaxiyou.cc/3070_1553588296422.235x235', //39
  'http://fimage.huaxiyou.cc/3070_1553588312811.235x235', //40
  'http://fimage.huaxiyou.cc/3070_1553588334362.235x235', //41
  'http://fimage.huaxiyou.cc/3070_1553588357133.235x235', //42
  'http://fimage.huaxiyou.cc/3070_1553588510100.235x235', //43
  'http://fimage.huaxiyou.cc/3070_1553588527840.235x235', //44
  'http://fimage.huaxiyou.cc/3070_1553588387630.235x235', //45

];
export const yiduiDataHandle = function (imgUrl) {
  let item = {
    title: '',
    desc: '',
    image: '',
  };
  switch (imgUrl) {
    case yiduiUrlArray[0]:
      item.title = '京东供应链'
      item.desc = '申请成功即可享受<br/>多个知名电商平台志愿者专属特惠<br/>（仅限微信内使用）'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/13.jpg'
      break;
    case yiduiUrlArray[1]:
      item.title = '宠物保险'
      item.desc = '志愿者特权卡×中国人寿宠物保险<br/>宠物责任险志愿者专享定价'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/7.jpg'
      break;
    case yiduiUrlArray[2]:
      item.title = '仓鼠优选'
      item.desc = '志愿者特权卡×仓鼠优选<br/>专享0元购+优惠券特权'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/6.jpg'
      break;
    case yiduiUrlArray[3]:
      item.title = '快买酒'
      item.desc = '志愿者特权卡×快买酒<br/>品质好酒0元享用优惠'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/14.jpg'
      break;
    case yiduiUrlArray[4]:
      item.title = '爱花居鲜花'
      item.desc = '申请成功即可享受<br/>爱花居鲜花专属折扣券30元'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/3.jpg'
      break;
    case yiduiUrlArray[5]:
      item.title = '顺丰'
      item.desc = '志愿者特权卡×顺丰<br/>顺丰2元寄件优惠券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/21.jpg'
      break;
    case yiduiUrlArray[6]:
      item.title = '闪送'
      item.desc = '志愿者特权卡×闪送<br/>同城60分钟快速达9折优惠服务'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/20.jpg'
      break;
    case yiduiUrlArray[7]:
      item.title = '农佳农产品'
      item.desc = '申请成功即可享受<br/>特定产品5折优惠+农产品专享0元购'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/19.jpg'
      break;
    case yiduiUrlArray[8]:
      item.title = '衣库租衣'
      item.desc = '申请成功即可享受<br/>大牌女装随心换穿立减优惠券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/26.jpg'
      break;
    case yiduiUrlArray[9]:
      item.title = '鹿熙生活'
      item.desc = '申请成功即可享受<br/>鹿熙生活进口玩具+小家电专享优惠'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/15.jpg'
      break;
    case yiduiUrlArray[10]:
      item.title = '爱回收'
      item.desc = '志愿者特权卡×爱回收<br/>专享888元回收大礼包'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/4.jpg'
      break;
    case yiduiUrlArray[11]:
      item.title = '货拉拉'
      item.desc = '志愿者特权卡×货拉拉<br/>无门槛85折优惠券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/12.jpg'
      break;
    case yiduiUrlArray[12]:
      item.title = '哈哈镜鸭脖'
      item.desc = '申请成功即可享受<br/>哈哈镜新人满100-70全场通用优惠券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/8.jpg'
      break;
    case yiduiUrlArray[13]:
      item.title = '途牛'
      item.desc = '志愿者特权卡×途牛旅游<br/>志愿者专享立减优惠券大礼包'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/23.jpg'
      break;
    case yiduiUrlArray[14]:
      item.title = '花筑旅行'
      item.desc = '申请成功即可享受<br/>花筑旅行立减优惠&专享优惠券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/11.jpg'
      break;
    case yiduiUrlArray[15]:
      item.title = '随手印'
      item.desc = '申请成功即可享受<br/>免费定制创意照片书服务'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/22.jpg'
      break;
    case yiduiUrlArray[16]:
      item.title = '秘密扣扣'
      item.desc = '申请成功即可享受<br/>大咖专栏精品课在线免费听'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/18.jpg'
      break;
    case yiduiUrlArray[17]:
      item.title = 'MES'
      item.desc = '志愿者特权卡×MES每实蛋糕<br/>志愿者专享30元优惠券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/32.jpg'
      break;
    case yiduiUrlArray[18]:
      item.title = '阿尔索外教英语'
      item.desc = '申请成功即可享受<br/>价值300元外教课+私人定制学习方案'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/1.jpg'
      break;
    case yiduiUrlArray[19]:
      item.title = 'VIPKID'
      item.desc = '申请成功即可领取<br/>VIPKID价值388试听课程'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/27.jpg'
      break;
    case yiduiUrlArray[20]:
      item.title = '海风课堂'
      item.desc = '申请成功即可领取<br/>海风家长课堂线上免费课程'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/9.jpg'
      break;
    case yiduiUrlArray[21]:
      item.title = '蜗牛动动'
      item.desc = '志愿者特权卡×蜗牛动动<br/>合作场馆免费健身体验2次'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/25.jpg'
      break;
    case yiduiUrlArray[22]:
      item.title = '汪正影业'
      item.desc = '申请成功即可享受<br/>价值1280元全家福拍摄一次'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/24.jpg'
      break;
    case yiduiUrlArray[23]:
      item.title = '拜博口腔'
      item.desc = '志愿者特权卡×拜博口腔<br/>价值550元免费口腔体检券+各类检查1-2折券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/5.jpg'
      break;
    case yiduiUrlArray[24]:
      item.title = '梦洁家纺'
      item.desc = '志愿者特权卡×梦洁家纺<br/>全类别折扣+免费床上用品洗护服务'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/17.jpg'
      break;
    case yiduiUrlArray[25]:
      item.title = '红星美凯龙'
      item.desc = '志愿者特权卡×红星美凯龙<br/>价值1800元的满减券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/10.jpg'
      break;
    case yiduiUrlArray[26]:
      item.title = '美年大体检'
      item.desc = '志愿者特权卡×美年大健康<br/>原价1940元体检套餐，志愿者专属价：350—450元'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/31.jpg'
      break;
    case yiduiUrlArray[27]:
      item.title = '贝黎诗'
      item.desc = '志愿者特权卡×贝黎诗<br/>300元无门槛代金券+志愿者专享价格'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/29.jpg'
      break;
    case yiduiUrlArray[28]:
      item.title = '蓝旗游泳'
      item.desc = '申请成功即可领取<br/>价值580元亲子游泳体验1次'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/30.jpg'
      break;
    case yiduiUrlArray[29]:
      item.title = '爱尔英智眼科'
      item.desc = '志愿者特权卡×爱尔英智眼科<br/>价值100元免费检查+配镜优惠'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/28.jpg'
      break;
    case yiduiUrlArray[30]:
      item.title = '阿姨帮家政'
      item.desc = '志愿者特权卡×阿姨帮<br/>300元家政礼包专享'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/40.jpg'
      break;
    case yiduiUrlArray[31]:
      item.title = '数理思维课程'
      item.desc = '志愿者特权卡×你拍一<br/>3-8岁在线小班数理课程'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/41.jpg'
      break;
    case yiduiUrlArray[32]:
      item.title = '进口红酒'
      item.desc = '志愿者特权卡×酒仙网<br/>法国进口葡萄酒0元享用'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/42.jpg'
      break;
    case yiduiUrlArray[33]:
      item.title = '家庭保洁'
      item.desc = '志愿者特权卡×大众工匠<br/>家庭保洁专享折扣'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/43.jpg'
      break;
    case yiduiUrlArray[34]:
      item.title = '儿童摄影'
      item.desc = '志愿者特权卡×纸飞机儿童摄影<br/>志愿者子女专享'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/44.jpg'
      break;
    case yiduiUrlArray[35]:
      item.title = '速8酒店'
      item.desc = '志愿者特权卡x速8酒店<br/>尊享全国订房50元优惠券礼包'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/45.jpg'
      break;
    case yiduiUrlArray[36]:
      item.title = '爱奇艺票务'
      item.desc = '志愿者特权卡x爱奇艺票务<br/>志愿者专享10元立减优惠券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/46.jpg'
      break;
    case yiduiUrlArray[37]:
      item.title = '移动电影院'
      item.desc = '志愿者特权卡×移动电影院<br/>25元APP全场通用兑换券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/47.jpg'
      break;
    case yiduiUrlArray[38]:
      item.title = '良品铺子'
      item.desc = '志愿者特权卡x良品铺子<br/>专区满199立减100元'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/48.jpg'
      break;
    case yiduiUrlArray[39]:
      item.title = '善诊'
      item.desc = '志愿者特权卡x善诊<br/>470元父母体检限量送'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/49.jpg'
      break;
    case yiduiUrlArray[40]:
      item.title = '蓝犀牛搬家'
      item.desc = '志愿者特权卡x蓝犀牛搬家<br/>志愿者专享20元搬家无门槛券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/50.jpg'
      break;
    case yiduiUrlArray[41]:
      item.title = 'e袋洗'
      item.desc = '志愿者特权卡xe袋洗<br/>志愿者专享100元洗衣券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/51.jpg'
      break;
    case yiduiUrlArray[42]:
      item.title = '土巴兔装修'
      item.desc = '志愿者特权卡x土巴兔装修<br/>志愿者专享价值3000元大礼包'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/52.jpg'
      break;
    case yiduiUrlArray[43]:
      item.title = '和鲜商城'
      item.desc = '志愿者特权卡x和鲜<br/>志愿者专享满199元减60元优惠券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/53.jpg'
      break;
    case yiduiUrlArray[44]:
      item.title = '青桔单车'
      item.desc = '志愿者特权卡x青桔单车<br/>免押金骑行，价值12元骑行礼包免费领'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/54.jpg'
      break;
    case yiduiUrlArray[45]:
      item.title = '驴妈妈旅游'
      item.desc = '志愿者特权卡x驴妈妈旅游<br/>旅游千元大礼包+上海迪士尼40元优惠券'
      item.image = 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/zhongyi/55.jpg'
      break;
    default:
      break;
  }
  return item;
}
